import React from "react"
import { Link as RouterLink } from "react-router-dom"

export interface LinkProps extends Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> {
  href?: string
  to?: string
  children?: React.ReactNode
  className?: string
}

export const Link: React.FC<LinkProps> = ({
  href,
  to,
  children,
  className,
  ...props
}) => {
  const target = to || href || "/"
  return (
    <RouterLink to={target} className={className} {...(props as any)}>
      {children}
    </RouterLink>
  )
}

export default Link
